export const environment = {
    apiUrl: import.meta.env.VITE_APP_API_URL,
    hotjarId: import.meta.env.VITE_APP_HOTJAR_SITE_ID,
    hotjarVersion: import.meta.env.VITE_APP_HOTJAR_TRACKING_VERSION,
    juneKey: import.meta.env.VITE_APP_JUNE_WRITE_KEY,
    defaultLanguage: 'en',
    languages: ['en'],
    version: '2.0',
};
